import * as React from 'react';
import ShowMore from '@sdk/components/ui/table/ShowMore';

import type { $stateType } from '../../../common/types/AngularTypes';

import EllipsisLink from './EllipsisLink';

type Props = {
  locations: Array<{ id: number; name: string }>;
  $state: $stateType;
};
const LocationsCell: React.FC<React.PropsWithChildren<Props>> = ({ locations, $state }) => {
  const onClick = (locationId: number): void => {
    $state.go('dashboard.manage.locations.edit', { groupId: locationId });
  };

  return (
    <ShowMore displayedItemsLimit={3}>
      {locations.map(({ id, name }) => (
        <EllipsisLink key={id} onClick={(): void => onClick(id)}>
          {name}
        </EllipsisLink>
      ))}
    </ShowMore>
  );
};

export default LocationsCell;
